import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { getEnvironment } from './pluginHelpers';

const doNotUpload = ['access_token=', 'password=']; // urls with these query paramaters will have everything removed after them before going to a breadcrumb.

let allowCapture = false;

function truncateUrlAtSensitiveParam(url, sensitiveParam) {
  const index = url.indexOf(sensitiveParam);
  if (index !== -1) {
    return url.substring(0, index + sensitiveParam.length);
  }
  return url;
}

function filterSensitiveDataFromBreadcrumb(breadcrumb) {
  if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
    // Handle successful API calls
    if (breadcrumb.data?.url) {
      doNotUpload.forEach((param) => {
        breadcrumb.data.url = truncateUrlAtSensitiveParam(breadcrumb.data.url, param);
      });
    }
  } else if (breadcrumb.category === 'console' && breadcrumb.data.arguments?.[1]?.config?.url) {
    // Handle unsuccessful API calls from console
    doNotUpload.forEach((param) => {
      breadcrumb.data.arguments[1].config.url = truncateUrlAtSensitiveParam(
        breadcrumb.data.arguments[1].config.url,
        param
      );
    });
  }
  return breadcrumb;
}

['production', 'staging', 'preprod', 'development'].includes(getEnvironment()) &&
  Sentry.init({
    Vue,
    sendClientReports: false,
    dsn: 'https://36755651f5871089c8aae48fb134ec66@o4509413026496512.ingest.us.sentry.io/4509586917425152',
    defaultIntegrations: false,
    environment: getEnvironment(),
    release: config.version,
    integrations: [
      // Enable essential integrations for breadcrumb collection
      Sentry.browserApiErrorsIntegration(),
      Sentry.breadcrumbsIntegration({
        console: true, // Capture console logs
        dom: true, // Capture DOM interactions
        fetch: true, // Capture fetch requests
        history: true, // Capture navigation
        sentry: true, // Capture Sentry events
        xhr: true, // Capture XHR requests
      }),
      Sentry.globalHandlersIntegration(),
      Sentry.httpContextIntegration(),
    ],
    // Set max breadcrumbs to ensure we capture enough context
    maxBreadcrumbs: 100,
    beforeSend(event, hint) {
      // Only let error events through when allowCapture is true
      // But breadcrumbs are already attached to the event at this point
      if (allowCapture) {
        return event;
      }
      return null;
    },
    beforeBreadcrumb: filterSensitiveDataFromBreadcrumb,
  });

export function captureException(exceptionOrEvent) {
  allowCapture = true;
  Sentry.captureException(exceptionOrEvent);
  allowCapture = false;
}

// Function to manually add breadcrumbs for important actions
export function addBreadcrumb(breadcrumb) {
  Sentry.addBreadcrumb(breadcrumb);
}

// Function to set tags for better error tracking and filtering
export function setTag(key, value) {
  Sentry.setTag(key, value);
}

// THIS IS COMPANY SPECIFIC SENTRY CONFIGURATION WE WILL ENABLE IF WE HAVE EEN.SENTRY.COM BACK.
// if (import.meta.env.PROD) {
//   Sentry.init({
//     Vue,
//     // this is added because backend version of sentry is below 21.9.0 and
//     // it does not support this feature
//     // we disable the feature to avoid crashes
//     sendClientReports: false,
//     dsn: 'https://7d8af248a0684f86a9661f5b94d5667b@sentry.eencloud.com/29',
//     integrations: [Sentry.browserTracingIntegration({ router })],
//     tracesSampleRate: 1,
//     beforeSendTransaction: () => false, // transaction types are not supported by backend version of sentry + were causing many calls from the PreviewTiles in the Grid.
//     beforeBreadcrumb(breadcrumb) {
//       doNotUpload.forEach((string) => {
//         if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
//           // filter out passwords and tokens from successfull api calls
//           const index = breadcrumb.data.url.indexOf(string);
//           if (index !== -1) {
//             breadcrumb.data.url = breadcrumb.data.url.substring(0, index + string.length);
//           }
//         } else if (
//           breadcrumb.category === 'console' &&
//           breadcrumb.data.arguments &&
//           Array.isArray(breadcrumb.data.arguments) &&
//           breadcrumb.data.arguments.length > 1 &&
//           breadcrumb.data.arguments[1].config
//         ) {
//           // filter out passwords and tokens from unsuccessfull api calls
//           const index = breadcrumb.data.arguments[1].config.url.indexOf(string);
//           if (index !== -1 && !isNaN(index)) {
//             breadcrumb.data.arguments[1].config.url = breadcrumb.data.arguments[1].config.url.substring(
//               0,
//               index + string.length
//             );
//           }
//         }
//       });
//       return breadcrumb;
//     },
//   });
// }

export default Sentry;
